import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), 'Brightness1Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Brightness1Sharp.js
// module id = 2476
// module chunks = 2